import { Vector3 } from 'three';

import { Point3D } from './types';

export const newVector3 = (point3D: Point3D) => new Vector3(point3D.x, point3D.y, point3D.z);
